import React from 'react';

const MissingIDCallback = ({ match, location, history }) => {
  const status = match.params.status;
  const hawb = (location && location.state && location.state.hawb) || '';
  const type = (location && location.state && location.state.type) || 'payment'; // 'payment' or 'update'

  function renderContent() {
    if (status === 'success') {
      const isPaymentFlow = type === 'payment';
      const successMessage = isPaymentFlow
        ? 'התשלום בוצע בהצלחה והפרטים עודכנו במערכת'
        : 'הפרטים עודכנו במערכת בהצלחה';
      
      return (
        <>
          <h1>
            {successMessage}
          </h1>
          <p style={{ marginTop: '25px' }}>
            <strong>מס’ למעקב: </strong>
            <span>&nbsp; {hawb}</span>
          </p>
          <div className='centered'>
            <button className='btn medium orange' onClick={() => history.push(`/tracking/${hawb}`)}>מעקב משלוח</button>
          </div>
        </>
      );
    }

    if (status === 'error') {
      return (
        <div className='sms-message'>
          <h1>
            ארעה שגיאה בביצוע התשלום {location.state && location.state.body && location.state.body.ErrorText && `(${location.state.body.ErrorText})`}.<br />
            אנא נסו שוב או צרו קשר עם שירות הלקוחות.
          </h1>
          {location.state && location.state.body && location.state.body.ErrorCode && `קוד שגיאה: ${location.state.body.ErrorCode}`}
        </div>
      );
    }

    if (status === 'cancelled') {
      return (
        <div className='sms-message'>
          <h1>
            הזמנת השירות בוטלה.
          </h1>
        </div>
      );
    }

    console.error(`Unexpected status ${status}`);
    return null;
  }

  return (
    <div className='sms-content-wrap'>
      {renderContent()}
    </div>
  );
};

export { MissingIDCallback };
